

<script>
import iframeMixin from '../iframeMixin.vue'

export default {
  mixins: [iframeMixin],
  data() {
      return {
          urlParam: '',
          name: '',
      }
  },
  activated() {
      this.urlParam = this.$route.query.id
      this.name = this.$route.query.name
  },
  computed: {
    url() {
     return `/ureport/preview?_u=mysql:${this.name}.ureport.xml&matchId=${this.urlParam}`
    },
  },
}
</script>
